import { useCallback, useState } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { createDateRange, toApiDateParams } from '@siteplus/analytics';
import { getCookieValue } from '../../../helpers/cookieHelper';
import { getAnalyticsProjectOverview } from '../api/analytics.api';
import { EMPTY_ANALYTICS_DATA } from '../helpers/analytics.helpers';
import { mapAnalyticsData } from '../helpers/mapAnalyticsData';

export const useAnalytics = ({ projectId, pageName = 'checkout-page' }) => {
  const [dateRange, setDateRange] = useState(() => createDateRange());
  const { dateFrom, dateTo } = toApiDateParams(dateRange);
  const accessToken = getCookieValue('_sp_accessToken')

  const analyticsQuery = useQuery({
    queryKey: ['analytics-overview', projectId, pageName, dateFrom, dateTo],
    queryFn: () =>
      getAnalyticsProjectOverview({
        accessToken,
        projectId,
        dateFrom,
        dateTo,
      }),
    enabled: Boolean(projectId && accessToken),
    placeholderData: keepPreviousData,
    select: (overviewResponse) =>
      mapAnalyticsData({
        overviewResponse,
        pageName,
      }),
  });

  const onDateRangeChange = useCallback((range) => {
    setDateRange(range);
  }, []);

  const analyticsData = analyticsQuery.data ?? EMPTY_ANALYTICS_DATA;

  return {
    ...analyticsData,
    dateRange,
    loading: analyticsQuery.isFetching,
    onDateRangeChange,
  };
};
